// Module
var code = "<div class=\"msso-screen msso-forgot-password-sent-screen\"> <div class=\"msso-text\">Password recovery email sent to your email address.</div> <div class=\"msso-link-button\"> <a href=\"javascript:void(0);\" data-screen-id=\"login\">Back to Login</a> </div> </div> ";
// Exports
module.exports = code;